<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5sdqJC/tc-custom/9781590209950.jpg?1738437302651" alt="This image is the cover for the book Wilfred Thesiger"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wilfred Thesiger
      </h1>
      <p class="bookDescription body article font2">
        <b>“A perceptive and gripping biography” of the enigmatic British explorer, photographer, and author of <i>Arabian Sands</i> (<i>Daily Mail</i>, UK).</b><br/><br/>Wilfred Thesiger, the last of the great gentlemen explorer-adventurers, journeyed for sixty years to some of the remotest, most dangerous places on earth, from the mountains of western Asia to the marshes of Iraq. The author of <i>Arabian Sands</i>, <i>The Marsh Arabs</i> and <i>The Life of my Choice, </i>he was a legend in his own lifetime. Yet his character and motivations have remained an intriguing enigma. <br/><br/>In this authorized biography—written with Thesiger’s support before he died in 2003 and with unique access to the rich Thesiger archive—Alexander Maitland investigates this fascinating figure’s family influences, his wartime experiences, his philosophy as a hunter and conservationist, his writing and photography, his friendships with Arabs and Africans amongst whom he lived, and his now-acknowledged homosexuality.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alexander Maitland
      </h2>
      
      <p class="authorDescription body article">Alexander Maitland was a close friend of Thesiger for forty years. He edited Thesiger's anthology, My Life and Travels and helped produce Thesiger's My Kenya Days: The Danakil Diary. He is the author of biographies of Freya Stark and John Hanning Speke.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Overlook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?756da957